<template>
  <div>
    <div
      v-if="loading"
      class="m-6 mt-16 text-center py-10 text-gray-400 bg-gray-50 rounded-xl border border-dashed border-gray-200"
    >
      <p class="mb-2">Loading modifier options...</p>
      <div
        class="inline-block w-6 h-6 border-2 border-gray-300 border-t-gray-500 rounded-full animate-spin"
        aria-hidden="true"
      />
    </div>
    <div v-else-if="activeGroup">
      <ModifierGroup
        :key="`group-${activeGroup.id}-${currentGroupIndex}`"
        :group="activeGroup"
        :group-index="currentGroupIndex"
        :modifier-groups="modifierGroups"
        :selected-modifiers="selectedModifiers"
        :has-attempted-submit="hasAttemptedSubmit"
        :currency="currency"
        @modifier-selected="handleModifierSelected"
      />
    </div>
  </div>
</template>

<script>
import ModifierGroup from "./ModifierGroup.vue";

export default {
  name: "ProductModifiers",
  components: {
    ModifierGroup
  },
  props: {
    modifierGroups: {
      type: Array,
      default: () => []
    },
    currentGroupIndex: {
      type: Number,
      default: 0
    },
    selectedModifiers: {
      type: Array,
      default: () => []
    },
    hasAttemptedSubmit: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: "$"
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    activeGroup() {
      return this.modifierGroups[this.currentGroupIndex] || null;
    }
  },
  methods: {
    handleModifierSelected({ group, modifier }) {
      this.$emit("modifier-selected", { group, modifier });
    }
  }
};
</script>
